module.exports = {
	"LANGUAGE": "Sprache",
	"HDR-obpa_fulltext_score": "Ergebnis",
	"HDR-obpa_name": "Name",
	"HDR-obpa_fulltext_summary": "Zusammenfassung",
	"QUERY LIMIT REACHED": "Es gibt mehr Ergebnisse als das, was angezeigt wird. Schränken Sie Ihre Suchkriterien ein.",
	"NO DOCUMENTS FOUND": "Keine Dokumente gefunden.",
	"OPEN IN NEW WINDOW": "In neuem Fenster öffnen",
	"DOWNLOAD NATIVE": "Im Original-Format herunterladen",
	"CLOSE": "Schließen",
	"SEARCH TYPE": "Suchtyp",
	"DOCUMENT TYPE": "Dokumenttyp",
	"SEARCH TERM": "Suchbegriff",
	"SEARCH": "Suche",
	"RESET": "Zurücksetzen",
	"DATE": "Datum",
	"FROM DATE": "Von-Datum",
	"TO DATE": "Bis-Datum",
	"LOADING": "Wird geladen...",
	"RETRY": "Erneut versuchen",
	"ERROR": "Fehler!",
	"ERROR: QUERIES": "Die Liste der Suchtypen konnte nicht abgerufen werden.",
	"ERROR: DOCTYPES": "Die Liste der Dokumenttypen konnte nicht abgerufen werden.",
	"ERROR: KEYWORDS": "Die Liste der Suchfelder konnte nicht abgerufen werden.",
	"ERROR: DOCUMENTS": "Die angeforderte Suche konnte nicht durchgeführt werden.",
	"FORM: INVALID FULLTEXT": "Das Feld muss mindestens {{chars}} Zeichen enthalten.",
	"FORM: INVALID DATE SHORT": "Format: {{format}} .",
	"FORM: REQUIRED KEYWORD": "Feld ist erforderlich.",
	"FORM: INVALID NUMERIC": "Das Feld muss eine Anzahl von bis zu {{digits}} Ziffern enthalten.",
	"FORM: INVALID DATE": "Das Feld muss dem Format {{format}} folgen.",
	"FORM: INVALID CURRENCY": "Das Feld muss ein gültiger Währungswert sein.",
	"FORM: INVALID FLOAT": "Das Feld muss eine Zahl sein.",
	"FORM: INVALID LENGTH": "Das Feld darf höchstens {{chars}} Zeichen enthalten.",
	"FORM: ERRORS": "Es gibt Fehler auf dem Formular.",
	"FORM: noDate": "Es muss ein Datumsbereich angegeben werden.",
	"FORM: noKeyword": "Es muss mindestens ein Feld angegeben werden.",
	"FORM: noDateOrKeyword": "Ein Datumsbereich ODER mindestens ein Feld muss angegeben werden.",
	"FORM: noDateAndKeyword": "Es muss ein Datumsbereich UND mindestens ein Feld angegeben werden."
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/de.json
// module id = 351
// module chunks = 0